"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 29866921781;
const slug = exports.slug = 'guides/api/crm/search';
// translate-ignore
const navTitle = exports.navTitle = 'Search';
const title = exports.title = 'CRM API | Search';
const name = exports.name = 'vNext Docs DP - Search';
const metaDescription = exports.metaDescription = 'The CRM search endpoints make getting data more efficient by allowing developers to filter, sort, and search across any CRM object type.';
const toc = exports.toc = [{
  "depth": 0,
  "id": "make-a-search-request",
  "label": "Make a search request",
  "parent": null
}, {
  "depth": 0,
  "id": "searchable-crm-objects-and-engagements",
  "label": "Searchable CRM objects and engagements",
  "parent": null
}, {
  "depth": 1,
  "id": "objects",
  "label": "Objects",
  "parent": "searchable-crm-objects-and-engagements"
}, {
  "depth": 1,
  "id": "engagements",
  "label": "Engagements",
  "parent": "searchable-crm-objects-and-engagements"
}, {
  "depth": 0,
  "id": "search-default-searchable-properties",
  "label": "Search default searchable properties",
  "parent": null
}, {
  "depth": 0,
  "id": "filter-search-results",
  "label": "Filter search results",
  "parent": null
}, {
  "depth": 0,
  "id": "search-through-associations",
  "label": "Search through associations",
  "parent": null
}, {
  "depth": 0,
  "id": "sort-search-results",
  "label": "Sort search results",
  "parent": null
}, {
  "depth": 0,
  "id": "paging-through-results",
  "label": "Paging through results",
  "parent": null
}, {
  "depth": 0,
  "id": "limitations",
  "label": "Limitations",
  "parent": null
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      h2: "h2",
      code: "code",
      pre: "pre",
      h3: "h3",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      em: "em",
      strong: "strong",
      ul: "ul",
      li: "li"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      RelatedApiLink,
      Alert
    } = _components;
  if (!Alert) _missingMdxReference("Alert", true);
  if (!RelatedApiLink) _missingMdxReference("RelatedApiLink", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Search"
    }), "\n", (0, _jsxRuntime.jsx)(RelatedApiLink, {}), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Use the CRM search endpoints to filter, sort, and search objects, records, and engagements across your CRM. For example, use the endpoints to get a list of contacts in your account, or a list of all open deals. To use these endpoints from an app, a CRM scope is required. Refer to this ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/authentication/working-with-oauth#scopes",
        children: "list of available scopes"
      }), " to learn which granular CRM scopes can be used to accomplish your goal."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Make a search request"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To search your CRM, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to the object's search endpoint. CRM search endpoints are constructed using the following format: ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v3/objects/{object}/search"
      }), ". In the request body, you'll include ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#filter-search-results",
        children: "filters"
      }), " to narrow your search by CRM property values. For example, the code snippet below would retrieve a list of all contacts that have a specific company email address."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "{\n  \"filterGroups\": [\n    {\n      \"filters\": [\n        {\n          \"propertyName\": \"email\",\n          \"operator\": \"CONTAINS_TOKEN\",\n          \"value\": \"*@hubspot.com\"\n        }\n      ]\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Each object that you search will include a set of ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#objects",
        children: "default properties"
      }), " that gets returned. For contacts, a search will return ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "createdate"
      }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "email"
      }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "firstname"
      }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "hs_object_id"
      }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "lastmodifieddate"
      }), ", and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "lastname"
      }), ". For example, the above request would return the following response:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "{\n  \"total\": 2,\n  \"results\": [\n    {\n      \"id\": \"100451\",\n      \"properties\": {\n        \"createdate\": \"2024-01-17T19:55:04.281Z\",\n        \"email\": \"testperson@hubspot.com\",\n        \"firstname\": \"Test\",\n        \"hs_object_id\": \"100451\",\n        \"lastmodifieddate\": \"2024-09-11T13:27:39.356Z\",\n        \"lastname\": \"Person\"\n      },\n      \"createdAt\": \"2024-01-17T19:55:04.281Z\",\n      \"updatedAt\": \"2024-09-11T13:27:39.356Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"57156923994\",\n      \"properties\": {\n        \"createdate\": \"2024-09-11T18:21:50.012Z\",\n        \"email\": \"emailmaria@hubspot.com\",\n        \"firstname\": \"Maria\",\n        \"hs_object_id\": \"57156923994\",\n        \"lastmodifieddate\": \"2024-10-21T21:36:02.961Z\",\n        \"lastname\": \"Johnson (Sample Contact)\"\n      },\n      \"createdAt\": \"2024-09-11T18:21:50.012Z\",\n      \"updatedAt\": \"2024-10-21T21:36:02.961Z\",\n      \"archived\": false\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To return a specific set of properties, include a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "properties"
      }), " array in the request body. For example:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "{\n  \"filterGroups\": [\n    {\n      \"filters\": [\n        {\n          \"propertyName\": \"annualrevenue\",\n          \"operator\": \"GT\",\n          \"value\": \"10000000\"\n        }\n      ]\n    }\n  ],\n  \"properties\": [\"annualrevenue\", \"name\"]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The response for the above request would look like:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "{\n  \"total\": 38,\n  \"results\": [\n    {\n      \"id\": \"2810868468\",\n      \"properties\": {\n        \"annualrevenue\": \"1000000000\",\n        \"createdate\": \"2020-01-09T20:11:27.309Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.333Z\",\n        \"hs_object_id\": \"2810868468\",\n        \"name\": \"Google\"\n      },\n      \"createdAt\": \"2020-01-09T20:11:27.309Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.333Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"2823023532\",\n      \"properties\": {\n        \"annualrevenue\": \"10000000000\",\n        \"createdate\": \"2020-01-13T16:21:08.270Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.064Z\",\n        \"hs_object_id\": \"2823023532\",\n        \"name\": \"Pepsi\"\n      },\n      \"createdAt\": \"2020-01-13T16:21:08.270Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.064Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"5281147580\",\n      \"properties\": {\n        \"annualrevenue\": \"50000000\",\n        \"createdate\": \"2021-02-01T21:17:12.250Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.332Z\",\n        \"hs_object_id\": \"5281147580\",\n        \"name\": \"CORKCICLE\"\n      },\n      \"createdAt\": \"2021-02-01T21:17:12.250Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.332Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"5281147581\",\n      \"properties\": {\n        \"annualrevenue\": \"1000000000\",\n        \"createdate\": \"2021-02-01T21:17:12.250Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.064Z\",\n        \"hs_object_id\": \"5281147581\",\n        \"name\": \"Ulta Beauty\"\n      },\n      \"createdAt\": \"2021-02-01T21:17:12.250Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.064Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"5281147583\",\n      \"properties\": {\n        \"annualrevenue\": \"50000000\",\n        \"createdate\": \"2021-02-01T21:17:12.251Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.332Z\",\n        \"hs_object_id\": \"5281147583\",\n        \"name\": \"Narvar\"\n      },\n      \"createdAt\": \"2021-02-01T21:17:12.251Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.332Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"5281496154\",\n      \"properties\": {\n        \"annualrevenue\": \"1000000000\",\n        \"createdate\": \"2021-02-01T21:17:12.267Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.332Z\",\n        \"hs_object_id\": \"5281496154\",\n        \"name\": \"Etsy Inc\"\n      },\n      \"createdAt\": \"2021-02-01T21:17:12.267Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.332Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"5281496155\",\n      \"properties\": {\n        \"annualrevenue\": \"1000000000\",\n        \"createdate\": \"2021-02-01T21:17:12.267Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.069Z\",\n        \"hs_object_id\": \"5281496155\",\n        \"name\": \"grubhub\"\n      },\n      \"createdAt\": \"2021-02-01T21:17:12.267Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.069Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"5281496157\",\n      \"properties\": {\n        \"annualrevenue\": \"1000000000\",\n        \"createdate\": \"2021-02-01T21:17:12.267Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.332Z\",\n        \"hs_object_id\": \"5281496157\",\n        \"name\": \"discover\"\n      },\n      \"createdAt\": \"2021-02-01T21:17:12.267Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.332Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"5281496158\",\n      \"properties\": {\n        \"annualrevenue\": \"50000000\",\n        \"createdate\": \"2021-02-01T21:17:12.268Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.064Z\",\n        \"hs_object_id\": \"5281496158\",\n        \"name\": \"Soludos\"\n      },\n      \"createdAt\": \"2021-02-01T21:17:12.268Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.064Z\",\n      \"archived\": false\n    },\n    {\n      \"id\": \"5281499282\",\n      \"properties\": {\n        \"annualrevenue\": \"1000000000\",\n        \"createdate\": \"2021-02-01T21:17:12.285Z\",\n        \"hs_lastmodifieddate\": \"2024-09-13T20:23:03.066Z\",\n        \"hs_object_id\": \"5281499282\",\n        \"name\": \"AEO Management Co.\"\n      },\n      \"createdAt\": \"2021-02-01T21:17:12.285Z\",\n      \"updatedAt\": \"2024-09-13T20:23:03.066Z\",\n      \"archived\": false\n    }\n  ],\n  \"paging\": {\n    \"next\": {\n      \"after\": \"10\"\n    }\n  }\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Searchable CRM objects and engagements"
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Objects"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The tables below contain the object search endpoints, the objects they refer to, and the properties that are returned by default."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "Search endpoint"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Object"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Default returned properties"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/carts/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Carts"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/companies/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Companies"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "name"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "domain"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/contacts/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contacts"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "firstname"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "lastname"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "email"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "lastmodifieddate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/deals/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deals"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "dealname"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "amount"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "closedate,``pipeline"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "dealstage"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/deal_split/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal splits"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/discounts/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Discounts"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/feedback_submissions/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Feedback submissions"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_createdate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/fees/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Fees"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/invoices/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoices"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/leads/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Leads"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/line_items/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line items"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "quantity"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "amount"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "price"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/orders/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Orders"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/commerce_payments/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payments"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/products/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Products"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "name"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "description"
            }), " ,", (0, _jsxRuntime.jsx)(_components.code, {
              children: "price"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/quotes/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quotes"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_expiration_date"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_public_url_key"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_status"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_title"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/subscriptions/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Subscriptions (Commerce)"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/taxes/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Taxes"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/tickets/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Tickets"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "content"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_pipeline"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_pipeline_stage"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_ticket_category"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_ticket_priority"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "subject"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "createdate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Engagements"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The table below contains the engagement search endpoints, the engagements they refer to, and the properties that are returned by default."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "Search endpoint"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Engagement"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Default returned properties"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/calls/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Calls"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_createdate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/emails/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Emails"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_createdate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/meetings/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meetings"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_createdate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/notes/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Notes"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_createdate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/tasks/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Tasks"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_createdate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_lastmodifieddate"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_object_id"
            })]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Search default searchable properties"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Search all default text properties in records of the specified object to find all records that have a value containing the specified string. By default, the results will be returned in order of object creation (oldest first), but you can override this with ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#sorting",
        children: "sorting"
      }), ". For example, the request below searches for all contacts with a default text property value containing the letter ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "X"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "curl https://api.hubapi.com/crm/v3/objects/contacts/search \\\n  --request POST \\\n  --header \"Content-Type: application/json\" \\\n  --header \"authorization: Bearer YOUR_ACCESS_TOKEN\" \\\n  --data '{\n    \"query\": \"x\"\n  }'\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Below are the properties that are searched by default through the above method:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "Search endpoint"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Object"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Default searchable properties"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/calls/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Calls"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_call_title"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_body_preview"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/companies/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Companies"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "website"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "phone"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "name"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "domain"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/contacts/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contacts"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "firstname"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "lastname"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "email"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "phone"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_additional_emails"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "fax"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "mobilephone"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "company"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_marketable_until_renewal"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/{objectType}/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Custom objects"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Up to 20 selected properties."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/deals/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deals"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "dealname"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "pipeline"
            }), ",", (0, _jsxRuntime.jsx)(_components.code, {
              children: "dealstage"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "description"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "dealtype"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/emails/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Emails"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_email_subject"
            })
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/feedback_submissions/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Feedback submissions"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_submission_name"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_content"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/meetings/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meetings"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_meeting_title"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_meeting_body"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/notes/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Notes"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_note_body"
            })
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/products/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Products"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "name"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "description"
            }), " ,", (0, _jsxRuntime.jsx)(_components.code, {
              children: "price"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_sku"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/quotes/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quotes"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_sender_firstname"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_sender_lastname"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_proposal_slug"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_title"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_sender_company_name"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_sender_email"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_quote_number"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_public_url_key"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/tasks/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Tasks"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_task_body"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_task_subject"
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "/crm/v3/objects/tickets/search"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Tickets"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: [(0, _jsxRuntime.jsx)(_components.code, {
              children: "subject"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "content"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_pipeline_stage"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_ticket_category"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "hs_ticket_id"
            })]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Filter search results"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Use filters in the request body to limit the results to only records with matching property values. For example, the request below searches for all contacts with a first name of ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Alice."
      })]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["When filtering search results for calls, conversations, emails, meetings, notes, or tasks, the property ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_body_preview_html"
        }), " is not supported. For emails, the properties ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_email_html"
        }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_body_preview"
        }), " are also not supported."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "curl https://api.hubapi.com/crm/v3/objects/contacts/search \\\n  --request POST \\\n  --header \"Content-Type: application/json\" \\\n  --header \"authorization: Bearer YOUR_ACCESS_TOKEN\" \\\n\n  --data '{\n    \"filterGroups\":[\n      {\n        \"filters\":[\n          {\n            \"propertyName\": \"firstname\",\n            \"operator\": \"EQ\",\n            \"value\": \"Alice\"\n          }\n        ]\n      }\n    ]\n  }'\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To include multiple filter criteria, you can group ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "filters"
      }), " within ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "filterGroups"
        })
      }), ":"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To apply ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "AND"
        }), " logic, include a comma-separated list of conditions within one set of ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "filters"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To apply ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "OR"
        }), " logic, include multiple ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "filters"
        }), " within a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "filterGroup"
        }), ".You can include a maximum of five ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "filterGroups"
        }), " with up to 6 ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "filters"
        }), " in each group, with a maximum of 18 filters in total. If you've included too many groups or filters, you'll receive a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "VALIDATION_ERROR"
        }), " error response. For example, the request below searches for contacts with the first name ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "Alice"
        }), " AND a last name other than ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "Smith"
        }), (0, _jsxRuntime.jsx)(_components.em, {
          children: ","
        }), " OR contacts that don't have a value for the property ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "email"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "curl https://api.hubapi.com/crm/v3/objects/contacts/search \\\n  --request POST \\\n  --header \"Content-Type: application/json\" \\\n  --header \"authorization: Bearer YOUR_ACCESS_TOKEN\" \\\n  --data '{\n  \"filterGroups\": [\n    {\n      \"filters\": [\n        {\n          \"propertyName\": \"firstname\",\n          \"operator\": \"EQ\",\n          \"value\": \"Alice\"\n        },\n        {\n          \"propertyName\": \"lastname\",\n          \"operator\": \"NEQ\",\n          \"value\": \"Smith\"\n        }\n      ]\n    },\n    {\n      \"filters\": [\n        {\n          \"propertyName\": \"email\",\n          \"operator\": \"NOT_HAS_PROPERTY\"\n        }\n      ]\n    }\n  ]\n}'\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "You can use operators in filters to specify which records should be returned. Values in filters are case-insensitive, with the following two exceptions:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "When filtering for an enumeration property, search is case-sensitive for all filter operators."
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["When filtering for a string property using ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "IN"
        }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "NOT_IN"
        }), " operators, the searched values must be lowercase.Below are the available filter operators:"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "Operator"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Description"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "LT"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Less than the specified value."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "LTE"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Less than or equal to the specified value."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "GT"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Greater than the specified value."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "GTE"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Greater than or equal to the specified value."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "EQ"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Equal to the specified value."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "NEQ"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Not equal to the specified value."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "BETWEEN"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["Within the specified range. In your request, use key-value pairs to set ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "highValue"
            }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "value"
            }), ". Refer to the example below the table."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "IN"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["Included within the specified list. Searches by exact match. In your request, include the list values in a ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "values"
            }), " array. When searching a string property with this operator, values must be lowercase. Refer to the example below the table."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "NOT_IN"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["Not included within the specified list. In your request, include the list values in a ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "values"
            }), " array. When searching a string property with this operator, values must be lowercase."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "HAS_PROPERTY"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Has a value for the specified property."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "NOT_HAS_PROPERTY"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Doesn't have a value for the specified property."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "CONTAINS_TOKEN"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["Contains a token. In your request, you can use wildcards (*) to complete a partial search. For example, use the value ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "*@hubspot.com"
            }), " to retrieve contacts with a HubSpot email address."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "NOT_CONTAINS_TOKEN"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Doesn't contain a token."
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example, you can use the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "BETWEEN"
      }), " operator to search for all tasks that were last modified within a specific time range:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "curl https://api.hubapi.com/crm/v3/objects/tasks/search \\\n  --request POST \\\n  --header \"Content-Type: application/json\" \\\n  --header \"authorization: Bearer YOUR_ACCESS_TOKEN\" \\\n  --data '{\n   \"filterGroups\":[{\n      \"filters\":[\n        {\n          \"propertyName\":\"hs_lastmodifieddate\",\n          \"operator\":\"BETWEEN\",\n          \"highValue\": \"1642672800000\",\n          \"value\":\"1579514400000\"\n        }\n      ]\n    }]\n}'\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For another example, you can use the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "IN"
      }), " operator to search for companies that have specified values selected in a dropdown property."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "curl https://api.hubapi.com/crm/v3/objects/companies/search \\\n  --request POST \\\n  --header \"Content-Type: application/json\" \\\n  --header \"authorization: Bearer YOUR_ACCESS_TOKEN\" \\\n  --data '{\n    \"filterGroups\":[\n      {\n        \"filters\":[\n          {\n           \"propertyName\":\"enumeration_property\",\n           \"operator\":\"IN\",\n          \"values\": [\"value_1\", \"value_2\"]\n        }\n        ]\n      }\n    ],\n   \"properties\": [\"annualrevenue\", \"enumeration_property\", \"name\"]\n  }'\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Search through associations"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Search for records that are associated with other specific records by using the pseudo-property ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "associations.{objectType}"
      }), ". For example, the request below searches for all tickets associated with a contact that has the contact ID of ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "123"
      }), ":"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "curl https://api.hubapi.com/crm/v3/objects/tickets/search \\\n  --request POST \\\n  --header \"Content-Type: application/json\" \\\n  --header \"authorization: Bearer YOUR_ACCESS_TOKEN\" \\\n  --data '{\n    \"filters\": [\n      {\n        \"propertyName\": \"associations.contact\",\n        \"operator\": \"EQ\",\n        \"value\": \"123\"\n      }\n    ]\n  }'\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["The option to search through custom object associations is not currently supported via search endpoints. To find custom object associations, you can use the ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/api/crm/associations/associations-v4",
          children: "associations API"
        }), "."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Sort search results"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Use a sorting rule in the request body to list results in ascending or descending order. Only one sorting rule can be applied to any search. For example, the request below sorts returned contacts with most recently created first:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "curl https://api.hubapi.com/crm/v3/objects/contacts/search \\\n  --request POST \\\n  --header \"Content-Type: application/json\" \\\n  --header \"authorization: Bearer YOUR_ACCESS_TOKEN\" \\\n  --data '{\n    \"sorts\": [\n      {\n        \"propertyName\": \"createdate\",\n        \"direction\": \"DESCENDING\"\n      }\n    ]\n  }'\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Paging through results"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["By default, the search endpoints will return pages of 10 records at a time. This can be changed by setting the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "limit"
      }), " parameter in the request body. The maximum number of supported objects per page is 200. For example, the request below would return pages containing 20 results each."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "curl https://api.hubapi.com/crm/v3/objects/contacts/search \\\n  --request POST \\\n  --header \"Content-Type: application/json\" \\\n  --header \"authorization: Bearer YOUR_ACCESS_TOKEN\" \\\n  --data '{\n    \"limit\": 20\n  }'\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To access the next page of results, you must pass an ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "after"
        })
      }), " parameter provided in the ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "paging.next.after"
        })
      }), " property of the previous response. If the ", (0, _jsxRuntime.jsx)(_components.strong, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "paging.next.after"
        })
      }), " property isn’t provided, there are no additional results to display. You must format the value in the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "after"
      }), " parameter as an integer. For example, the request below would return the next page of results:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "curl https://api.hubapi.com/crm/v3/objects/contacts/search \\\n  --request POST \\\n  --header \"Content-Type: application/json\" \\\n  --header \"authorization: Bearer YOUR_ACCESS_TOKEN\" \\\n  --data '{\n    \"after\": \"20\"\n  }'\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Limitations"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "It may take a few moments for newly created or updated CRM objects to appear in search results."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Archived CRM objects won’t appear in any search results."
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["The search endpoints are ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/apps/api-usage/usage-details",
          children: "rate limited"
        }), " to ", (0, _jsxRuntime.jsx)("u", {
          children: "five"
        }), " requests per second per account."]
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "The maximum number of supported objects per page is 200."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "A query can contain a maximum of 3,000 characters. If the body of your request exceeds 3,000 characters, a 400 error will be returned."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "The search endpoints are limited to 10,000 total results for any given query. Attempting to page beyond 10,000 will result in a 400 error."
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["When ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "#filter-search-results",
          children: "filtering"
        }), ", you can include a maximum of five ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "filterGroups"
        }), " with up to six ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "filters"
        }), " in each group, with a maximum of 18 filters in total."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["When searching for phone numbers, HubSpot uses special calculated properties to standardize the format. These properties all start with ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_searchable_calculated_*"
        }), ". As a part of this standardization, HubSpot only uses the area code and local number. You should refrain from including the country code in your search or filter criteria."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}